var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer p-st",class:{ 'bg-light': !_vm.nightMode, 'bg-dark2': _vm.nightMode }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-1 pt-1"},[_c('span',[_vm._v("© 2026 JooYeong. Last updated: March 10, 2026")])])
}]

export { render, staticRenderFns }